import { withTranslation } from "next-i18next";
import { useEffect, useRef } from "react";
import classNames from "classnames";
import CloseButton from "../CloseButton";
import QuickAddToClosetOffCanvasVariants from "./QuickAddToClosetOffCanvasVariants";

function QuickAddToClosetCustomInsideOffCanvas({
  show,
  onHide,
  productWithVariants,
  dataFromAlgolia,
  t,
}) {
  const offCanvasRef = useRef(null);
  const isDoubleSize = productWithVariants?.variants?.some((variant) =>
    variant.size?.value?.includes("x"),
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (show && offCanvasRef?.current && !offCanvasRef?.current.contains(event.target)) {
        onHide();
      }
    };

    if (show) document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show, onHide]);

  return (
    <div
      ref={offCanvasRef}
      className={classNames(
        "quick-add-to-closet-custom-inside-offcanvas d-none d-lg-block",
        show && "show",
        isDoubleSize && "double-size",
      )}
    >
      <div className="quick-add-to-closet-custom-inside-offcanvas-header">
        <h6 className="quick-add-to-closet-custom-inside-offcanvas-header-title mb-0">
          {t("common:quick_add_to_closet.offcanvas.title")}
        </h6>
        <CloseButton onClick={onHide} />
      </div>

      <QuickAddToClosetOffCanvasVariants
        productWithVariants={productWithVariants}
        onHide={onHide}
        dataFromAlgolia={dataFromAlgolia}
      />
    </div>
  );
}

export default withTranslation("common")(QuickAddToClosetCustomInsideOffCanvas);
